import * as T from 'three';
import { Component } from './live-codec.js';
// point_worldtext screen-facing labels use Source units, depth testing and the
// streamed parent transform. They are ordinary scene entities, not roster UI.
export function createWorldText(state, resources) {
    const canvas = document.createElement('canvas'), context = canvas.getContext('2d');
    const text = state.text.replace(/\x07[\da-f]{6}|\x08[\da-f]{8}/gi, '').replace(/[\x00-\x1f\x7f-\x9f]/g, '');
    context.font = '48px sans-serif';
    canvas.width = Math.min(4096, Math.ceil(context.measureText(text).width) + 8); canvas.height = 64;
    context.font = '48px sans-serif'; context.textBaseline = 'middle'; context.lineWidth = 4; context.strokeStyle = '#222'; context.fillStyle = '#fff';
    context.strokeText(text, 4, 32); context.fillText(text, 4, 32);
    const texture = new T.CanvasTexture(canvas); texture.colorSpace = T.SRGBColorSpace;
    const color = state.color, material = new T.MeshBasicMaterial({ map: texture, transparent: true, depthWrite: false, side: T.DoubleSide,
        color: new T.Color((color & 255) / 255, (color >>> 8 & 255) / 255, (color >>> 16 & 255) / 255), opacity: (color >>> 24) / 255 });
    const geometry = new T.PlaneGeometry(canvas.width / 48 * state.size, canvas.height / 48 * state.size);
    geometry.translate(state.orientation ? 0 : canvas.width / 96 * state.size, state.size / 2, 0);
    const mesh = new T.Mesh(geometry, material);
    if (!state.orientation) mesh.quaternion.setFromRotationMatrix(new T.Matrix4().makeBasis(new T.Vector3(0,-1,0), new T.Vector3(0,0,1), new T.Vector3(-1,0,0)));
    resources.add(texture); resources.add(material); resources.add(geometry);
    return mesh;
}

const rotation = new T.Quaternion(), cameraRotation = new T.Quaternion(), up = new T.Vector3(0, 0, 1), right = new T.Vector3(), normal = new T.Vector3(), basis = new T.Matrix4();
export function updateWorldText(entity, camera) {
    if (!camera) return;
    const orientation = entity.state.components[Component.WorldText].orientation;
    const mesh = entity.worldText;
    if (orientation === 1) camera.getWorldQuaternion(cameraRotation);
    else if (orientation === 2) {
        right.setFromMatrixColumn(camera.matrixWorld, 0); right.z = 0; right.normalize();
        if (!right.lengthSq()) right.set(1, 0, 0);
        normal.crossVectors(right, up); cameraRotation.setFromRotationMatrix(basis.makeBasis(right, up, normal));
    } else return;
    entity.object.getWorldQuaternion(rotation).invert(); mesh.quaternion.copy(rotation).multiply(cameraRotation);
    mesh.updateMatrixWorld(true);
}
